import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import PickupSessionCreateEditForm from './Components/PickupSessionCreateEditForm';
import PickupSessionApi from './PickupSessionApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: PickupSessionCreateEditForm,
                getCreate: PickupSessionApi.create,
                defaults: {},
                successMessage: "Pickup Session Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}